<template>
  <Modal name="newReport" v-bind="$attrs" :key='id'>
    <template v-slot:header>
        <h1 v-if="!editMode">{{ $t('add_new_report') }}</h1>
        <h1 v-else>{{ $t('edit_report') }}</h1>
    </template>
    <template v-slot:body>
        <div class="row">
            <div class="label-wrapper name">
                <feather size="20px" stroke-width="1" type="folder" />
                <label>{{ $t('report_name') }}</label>
            </div>
            <div class="form">
                <input ref="name" type="text" name="name" v-model="reportName" maxlength="100" required v-on:keyup.enter="submit"/>
            </div>
        </div>
        <div class="row" v-show="userType.length > 1">
            <div class="label-wrapper userType">
                <feather size="20px" stroke-width="1" type="type" />
                <label>{{ $t('save_report_in') }}</label>
            </div>
            <div class="form">
                <multiselect v-model="setUserType" :options="userType" :allow-empty="false" :preselect-first="true" label="name" track-by="id" :searchable="false" :close-on-select="true" :show-labels="false" :placeholder="$t('select')"></multiselect>
            </div>
        </div>
    </template>
    <template v-slot:footer>
        <div class="btn btn-primary submit" :class="!isValid ? 'disabled' : ''" @click="submit">
            <feather size="24px" type="send" /> {{ $t('submit') }}
        </div>
    </template>
</Modal>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import Modal from '../modules/modals/components/Modal'

export default {
    name: 'modalNewReport',
    props: ['id'],
    components: {
        Modal,
    },
    computed: {
        ...mapGetters([
            'isValid',
            'newReport',
            'userType'
        ]),
        editMode() {
            return !!this.id;
        },
        reportName: {
                get() {
                    return this.newReport.name
                },
                set(value) {
                    this.setNewReportItem({name: value})
                }
        },
        setUserType: {
            get() {
                if(this.newReport.type_id){
                    return this.userType.find(type => type.id == this.newReport.type_id)
                } else {
                    return null
                }
            },
            set(value) {
                this.setNewReportItem({type_id: value ? value.id : null})
            }
        }
    },
    methods: {
        ...mapMutations({
            setNewReportItem: 'setNewReportItem',
            chooseServiceType: 'chooseServiceType'
        }),
        ...mapActions({
            saveReport: 'saveReport',
        }),
        setUrlParam(name, value){
            if(name && value){
                const params = new URLSearchParams(location.search);
                params.set(name, value);

                window.history.replaceState({}, '', `${location.pathname}?${params}`);
                
            }
        },
        submit(){
            if(this.isValid){
                this.saveReport(this.editMode ? null : 'new').then((response)=> {
                    this.setUrlParam('id',response.id)
                    this.chooseServiceType(null)
                })
                window.onbeforeunload = null
                this.$attrs.close()
            }
        },
    },
    mounted() {
        this.setNewReportItem({name: ''})
        this.$nextTick(()=>{
            this.$refs.name.focus()
        })
    }
}
</script>

<style lang="sass" scoped>
h1
    font-size: 25px!important
label
    font-weight: 700
    font-size: 17px
input, select, textarea
    border: 1px solid #F0F1F3!important
    border-radius: 7px
    width: 100%
input[type='checkbox']
    min-width: 25px
    width: inherit
    height: 25px
.label-wrapper
    display: flex
    align-items: center
    margin-bottom: 4px
    label
        margin-left: 10px
.row
    .col
        flex: 1
    &:not(:last-child)
        margin-bottom: 1.5rem
    .form
        padding-left: 30px
</style>
